import styles from "./HomeWithNoFollows.module.scss"
import {
  HomeHeaderWithNoFollows,
  Page,
} from "src/components"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.home.follow_only_with_no_follows."

export function HomeWithNoFollows() {
  const polyglot = usePolyglot()

  return (
    <>
      <HomeHeaderWithNoFollows>
        {polyglot.t("components.page_header.pages.home")}
      </HomeHeaderWithNoFollows>
      <Page>
        <div className={styles.container}>
          <div className={styles.title}>
            {polyglot.t(`${polyglotPrefix}title`)}
          </div>
          <div className={styles.body}>
            {polyglot.t(`${polyglotPrefix}go_to_my_account`)}
          </div>
          <div className={styles.body}>
            {polyglot.t(`${polyglotPrefix}go_to_data_sharing`)}
          </div>
        </div>
      </Page>
    </>
  )
}
